import React, { Fragment } from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import { DragHandle } from "@material-ui/icons";

const DragItem = styled.div`
  display:flex;
  color: #333333;
  align-items:center;
  justify-content:center;
  background:rgb(245, 245, 245);
  width:300px;
  padding:6px 6px;
  margin:4px;
`;

const Spacer = styled.div`
  flex-grow:1;
`;

const StyledDragHandle = styled(DragHandle)`
  & {
    font-size:36px;
    color:#333333;
  }
`;
class DraggableMetric extends React.Component {
  render() {
    const { metric } = this.props;

    return (
      <Draggable draggableId={metric.screenElementId} index={this.props.index}>
        {
          provided => (
            <DragItem
              id={this.props.id}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
            >
              <div>{metric.title}</div>
              <Spacer />
              <StyledDragHandle />
            </DragItem>
          )
        }
      </Draggable>
    );
  }
}

export default DraggableMetric;
